// extracted by mini-css-extract-plugin
export var form = "_4i-0";